<template>
    <div class="gift-detail">
        <div class="left-container">
            <img class="image" src="../assets/img/gift/teacher-pic001.png">
            <img class="icon" src="../assets/img/gift/1st.png">
        </div>
        <div class="right-container">
            <div class="name">
                <div class="name-title">
                    <img src="../assets/img/gift/icon-user.png"> Teacher Name
                </div>
                <div class="teacher-name">
                    Ms. Dengdeng
                </div>
            </div>
            <div class="gift">
                <div class="gift-title">
                    <img src="../assets/img/gift/icon-gift-box.png"> Selected Gift for Your Teacher
                </div>
                <div class="gift-image">
                    <img src="../assets/img/gift/gift-ui-01.png">
                    <img src="../assets/img/gift/gift-ui-02.png">
                    <img src="../assets/img/gift/gift-ui-03.png">
                    <img src="../assets/img/gift/gift-ui-04.png">
                </div>
            </div>
            <div class="quantity">
                <img src="../assets/img/gift/icon-Quantity.png"> Quantity
                <span class="input">
                    <img @click="handleQuantity('minus')" src="../assets/img/gift/icon-minus.png">
                    <el-input v-model="quantity" placeholder=""></el-input>
                    <img @click="handleQuantity('plus')" class="plus" src="../assets/img/gift/icon-plus.png">
                </span>
            </div>
            <div class="submit">
                <router-link to="payment">
                    <el-button>Submit</el-button>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Gift Detail",
        data() {
            return {
                quantity: 1
            }
        },
        methods: {
            handleQuantity(type) {
                if(type == 'minus'){
                    if(this.quantity > 1){
                        this.quantity -= 1;
                    }
                } else{
                    this.quantity += 1;
                }
            }
        },
    }
</script>

<style lang='scss' type='text/css'>
    @import "../styles/pc/GiftDetail.scss";
    @import "../styles/mobile/GiftDetail.scss";
</style>
